import { ButtonPurple } from 'components/Button'
import styled from 'styled-components/macro'

const SettingsPageWrapper = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${({ theme }) => `calc(100vh - ${theme.navHeight}px - 5rem)`};
  padding: 24px;
`

const DropLocalStorageButton = styled(ButtonPurple)`
  width: auto;
  min-width: 240px;
  border-radius: 12px;
`

export default function SettingsPage() {
  const dropLocalStorage = () => {
    window.localStorage.clear()
    window.location.reload()
  }

  return (
    <SettingsPageWrapper>
      <DropLocalStorageButton onClick={dropLocalStorage}>DROP LOCAL STORAGE</DropLocalStorageButton>
    </SettingsPageWrapper>
  )
}
